import React, { useState } from "react";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";

import { RNHEstablecimientoIns } from "services/services-mia/programa-salud/estructuras/RNHEstablecimientoIns";

import EstablecimientoFormulario, {
    valoresVacios,
} from "pages/programa-salud/estructuras/establecimientos/EstablecimientoFormulario";

// Tipo de componente que administra esta página; el service lo manda como
// `rnhTipoComponenteCod`. Códigos: H dirección · D departamento · I división ·
// U unidad · C caps · R uresa · P puesto · O posta.
// Si no se manda, el back asume dirección ("H").
const TIPO = "C";

export default function InsertModal({ updateList, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    const handleCreateCap = async (values) => {
        setInRequest(true);

        // lat y lng ya vienen redondeados del mapa: los pone useUbicacion y el formulario los
        // mergea al enviar.
        const response = await RNHEstablecimientoIns(credentials, {
            ...values,
            type: TIPO,
        });

        if (response.ok) {
            setSnackBarInfo({
                message: "CAP creado correctamente",
                severity: "success",
                open: true,
            });
            updateList();
            closeModal();
        }

        setInRequest(false);
    };

    return (
        <EstablecimientoFormulario
            initialValues={valoresVacios()}
            onSubmit={handleCreateCap}
            botonTexto="Crear"
            inRequest={inRequest}
            closeModal={closeModal}
            esAlta
            conPermisos
        />
    );
}
